import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule, Platform } from '@ionic/angular';
import { MensagemProvider } from 'src/app/services/mensagem/mensagem';
import { NoticiaProvider } from 'src/app/services/noticia/noticia';
import { OracaoProvider } from 'src/app/services/oracao/oracao';
import { UserProvider } from 'src/app/services/user/user';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'botao-image',
  templateUrl: 'botao-image.html',
  styleUrls: ['botao-image.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
  ]
})
export class BotaoImageComponent {
  @Input()
  config: any;
  new: boolean = false;

  constructor(public mensagemProvider: MensagemProvider,
    public oracaoProvider: OracaoProvider,
    public noticiaProvider: NoticiaProvider,
    public userProvider: UserProvider,
    public platform: Platform
  ) { }


  getBackground() {
    if (this.config.image) {

      if(this.config.tamanho === '5') {
        if (this.config.image.includes('https://')) {
          return ' linear-gradient(to bottom, ' + this.config.degrade_inicio + ', ' + this.config.degrade_fim + '), url(' + this.config.image + ') no-repeat scroll center center /cover';
        } else {
          return ' linear-gradient(to bottom, ' + this.config.degrade_inicio + ', ' + this.config.degrade_fim + '), url(' + environment.DOWNLOAD_URL + '/' + this.config.image + ') no-repeat scroll center center /cover';
        }
      }

      if (this.config.image.includes('https://')) {

        return ' linear-gradient(to bottom, ' + this.config.degrade_inicio + ', ' + this.config.degrade_fim + '), url(' + this.config.image + ') no-repeat scroll center center /contain';
      } else {
        return ' linear-gradient(to bottom, ' + this.config.degrade_inicio + ', ' + this.config.degrade_fim + '), url(' + environment.DOWNLOAD_URL + '/' + this.config.image + ') no-repeat scroll center center /contain';
      }
    } else {
      return ' linear-gradient(to bottom, ' + this.config.degrade_inicio + ', ' + this.config.degrade_fim + '), url(' + this.config.tamanho.imagem + ') no-repeat scroll center center /contain';
    }
  }

  getFontColor() {
    return this.config.font_color;
  }

  getFontSize() {
    if (this.platform.width() >= 768) {
      return (this.config.font_size * 2) + 'px';
    } else {
      return (this.config.font_size) + 'px';
    }
  }

  getFontWeight() {
    return this.config.font_weight;
  }
}
